import { createSlice } from '@reduxjs/toolkit';
import { fetchProfile } from '../actions/profileActions';

interface ProfileState {
  data: any;
  loading: boolean;
  error: string | null;
}

// Load profile state from local storage
const loadProfileState = (): ProfileState => {
  try {
    const serializedState = localStorage.getItem('profile');
    return serializedState
      ? JSON.parse(serializedState)
      : { data: null, loading: false, error: null };
  } catch (error) {
    console.error('Failed to load profile state from local storage:', error);
    return { data: null, loading: false, error: null };
  }
};

// Save profile state to local storage
const saveProfileState = (state: ProfileState) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('profile', serializedState);
  } catch (error) {
    console.error('Failed to save profile state to local storage:', error);
  }
};

const initialState: ProfileState = loadProfileState();

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    clearProfile: state => {
      state.data = null;
      state.loading = false;
      state.error = null;
      localStorage.removeItem('profile');
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchProfile.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload?.data || null; // Add null check
        saveProfileState(state); // Save updated state to local storage
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.loading = false;
        // state.error = action.payload || 'Failed to fetch profile';
        saveProfileState(state); // Save state with error to local storage
      });
  },
});

export const { clearProfile } = profileSlice.actions;
export default profileSlice.reducer;
